import type { ModalDialogFooterProps } from "./modal-dialog.types";

import styles from "./modal-dialog-footer.module.css";

export function ModalDialogFooter({
  children,
  className = "",
  ...props
}: ModalDialogFooterProps) {
  return (
    <div className={`${styles.Container} ${className}`} {...props}>
      {children}
    </div>
  );
}
